const Element_Ids = {
  price: 'upsell-price',
  priceTargetElement: 'upsell-price-target',
  varaintSelector: 'upsell-variant-selector-',
  addOnItemContainer: 'upsell-addon-'
};

export default Element_Ids;
